export type UserType = {
  id?: number | null;
  dashboard_access_timeout?: string | number | null;
  email: string;
  name: string;
  role: {
    id?: number | null;
    display_name?: string;
  };
  role_id: number;
  account: {
    id?: number | null;
    display_name?: string;
  };
  account_id?: number;
  phone?: string;
  phone_country_code?: string;
  is_active?: boolean;
  vantage_tour_completed?: boolean;
  last_activity?: Date;
  updated_at?: Date;
  disable_sso?: boolean;
};

export type UsersIndexQuery = {
  page: number;
  results_per_page: number;
  name?: string;
  sortBy?: string;
  sortDesc: boolean;
  account?: number;
  archived?: boolean;
};

export type UserData = {
  id?: number;
  account_id?: number;
  account_logo?: string;
  account_name?: string;
  accessToken: string;
  email: string;
  expires_at: Date;
  first_name?: string;
  name: string;
  phone: string;
  phone_country_code: string;
  profile_status?: ProfileStatusEnum;
  role: string;
  role_name: string;
  vantage_tour_completed?: boolean;
  scopes?: string[];
  features?: string[];
};

export enum ProfileStatusEnum {
  INCOMPLETE_CLIENT_INPUT = -1,
  INCOMPLETE_MESHH_INPUT = -2,
  PENDING_APPROVAL = -3,
  PENDING_REAPPROVAL = -4,
  CHANGES_REJECTED = -5,
  COMPLETE = 1,
}
